import React from 'react';
import { motion } from 'framer-motion';
import { Download, Printer, Clock } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-294">
      <div className="max-w-4xl mx-auto text-center" data-id="element-295">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-296">
          <div className="inline-block bg-green-100 text-green-800 px-6 py-2 rounded-full text-xl font-black mb-6 uppercase tracking-wider" data-id="element-297">
            ✅ LA SOLUCIÓN
          </div>

          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-8" data-id="element-298">
            MEGA KIT LECTOESCRITURA
          </h2>

          <p className="text-xl md:text-2xl text-gray-700 font-medium mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-299">
            Un sistema completo de lectura + escritura + comprensión, con
            actividades visuales y auditivas, ejercicios progresivos y
            materiales imprimibles, para que avances con tu hijo{' '}
            <span className="bg-yellow-200 font-bold px-1" data-id="element-300">
              sin depender de pantallas ni de "tips random".
            </span>
          </p>
        </motion.div>

        <div className="bg-[#F0F8FF] rounded-3xl p-8 md:p-12 shadow-lg border border-blue-100" data-id="element-301">
          <h3 className="text-3xl font-black text-gray-900 mb-10" data-id="element-302">
            El método es simple:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-303">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-304">
              <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4" data-id="element-305">
                <Download className="w-8 h-8" data-id="element-306" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-307">Paso 1</h4>
              <p className="text-gray-600 font-medium" data-id="element-308">
                📥 Descargás el material
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-309">
              <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4" data-id="element-310">
                <Printer className="w-8 h-8" data-id="element-311" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-312">Paso 2</h4>
              <p className="text-gray-600 font-medium" data-id="element-313">
                🖨️ Imprimís lo necesario
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-314">
              <div className="w-16 h-16 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center mb-4" data-id="element-315">
                <Clock className="w-8 h-8" data-id="element-316" />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-317">Paso 3</h4>
              <p className="text-gray-600 font-medium" data-id="element-318">
                ⏱️ Practican 5 a 10 minutos por día
              </p>
            </div>
          </div>

          <p className="mt-10 text-2xl font-black text-blue-900" data-id="element-319">
            Sin vueltas. Sin estrés. Sin "a ver qué hacemos hoy".
          </p>
        </div>
      </div>
    </section>;
}